// The node name is the panel's single display heading. Everything inside the
// scrollable form is supporting hierarchy and stays in the denser UI face.
export const FLOW_PANEL_SECTION_TYPOGRAPHY = [
  '[&_.text-h1-400]:font-inter',
  '[&_.text-h1-500]:font-inter',
  '[&_.text-h2-400]:font-inter',
  '[&_.text-h2-500]:font-inter',
  '[&_.text-h3-400]:font-inter',
  '[&_.text-h3-500]:font-inter',
  '[&_.text-h3-600]:font-inter',
  '[&_.text-h4-400]:font-inter',
  '[&_.text-h4-500]:font-inter',
  '[&_.text-h4-600]:font-inter',
  '[&_.text-xl-500]:font-inter',
].join(' ')
